import { useFetcher } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faRedoAlt, faTrash } from "@fortawesome/free-solid-svg-icons"

import type { Queue } from "./QueueDetail"

export const QueueError = ({ queue }: QueueErrorProps) => {
  const fetcher = useFetcher()
  return (
    <div className="flex max-h-40 flex-col items-start justify-start gap-2 overflow-y-auto pb-2.5">
      <div className="text-black flex w-full justify-between text-sm font-bold">
        <h3 className="grow">Errors</h3>
        <span>{queue.errorCounts.length}</span>
      </div>
      {queue.errorCounts.length < 1 ? (
        <div className="w-full text-sm">There are no errors to display</div>
      ) : (
        <ul className="w-full grow">
          {queue.errorCounts.map((errorCount, index) => (
            <li
              key={`${queue.name}-e-${index}`}
              className="text-black flex items-center gap-3 py-1 px-2 text-sm shadow-md"
            >
              <div className="grow">{errorCount.error}</div>
              <span
                aria-label="Number of errors"
                className="mr-2 inline-flex items-center rounded-xl bg-info px-2.5 py-0.5 text-xs font-medium text-info-content"
              >
                {errorCount.count}
              </span>
              <fetcher.Form method="post">
                <input type="hidden" name="action" value="retry" />
                <input type="hidden" name="queueName" value={queue.name} />
                <input type="hidden" name="error" value={errorCount.error} />
                <button type="submit" title="Retry all errors">
                  <FontAwesomeIcon icon={faRedoAlt} />
                </button>
              </fetcher.Form>
              <fetcher.Form method="post">
                <input type="hidden" name="action" value="delete" />
                <input type="hidden" name="queueName" value={queue.name} />
                <input type="hidden" name="error" value={errorCount.error} />
                <button type="submit" title="Delete all errors">
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </fetcher.Form>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

interface QueueErrorProps {
  queue: Queue
}
